import React, { useEffect } from "react"
import { Link } from "react-router-dom"
import Header from "../shared/Header/Header"
import { RequestError } from "../shared/RequestError"
import { Spinner } from "../shared/Spinner"
import { BandEditForm } from "../../pages/BandEditPage/BandEditForm"
import style from "../shared/PageStyle.module.css"
import { useBand } from "../../hooks/useBand"
import { useQueryClient } from "react-query"
import Footer from "../shared/Footer/Footer"

export const NewBandScreen = ({ user }) => {
  const bandId = user?.band_id
  const queryClient = useQueryClient()

  useEffect(() => {
    queryClient.invalidateQueries("user")
  }, [bandId])

  return (
    <div className={style.rootElStyle}>
      <Header user={user} />
      <>
        <div className="grid grid-cols-12 w-full pb-2 px-4">
          <div className="col-span-12 border-b-4 mt-4 mb-8 border-black">
            <h1 className="lg:col-span-8 col-span-12 font-extrabold text-5xl lg:text-3xl uppercase">
              Profile Setup
            </h1>
          </div>
          <div className="col-span-12">
            <FullBandForm bandId={bandId} />
          </div>
        </div>
      </>
      <Footer />
    </div>
  )
}

export const FullBandForm = ({ bandId }) => {
  const {
    status: bandStatus,
    data: bandData,
    error: bandError,
  } = useBand(bandId, "active", "backline")
  var band = bandData?.band

  return (
    <>
      {bandStatus === "error" ? (
        <RequestError error={bandError} />
      ) : bandStatus === "loading" || !band ? (
        <Spinner />
      ) : (
        <>
          <BandEditForm band={band} isOnboarding={true} />
          <div className="mt-4">
            <Link
              to={band.band_path}
              className="inline-block text-center focus:outline-none border text-base border-green-700 text-green-700 px-2 py-1 rounded-sm align-bottom"
            >
              Visit Your Profile Page
            </Link>
          </div>
        </>
      )}
    </>
  )
}
